module.exports = __webpack_public_path__ + "static/media/remove-icon.242363e0.svg";